import { useEffect, useState } from 'react';
import { TAXPAYER_SUMMARY_STATUS } from '../../constants';
import { getTaxpayerInformationSummaryPromise } from '../../get_taxpayer_information';
import {
    PayoutMissingInformation,
    TaxpayerMissingInformation,
} from '../../types';

export const GetTaxpayerInformation = (
    organizationId: string,
): TaxpayerMissingInformation | PayoutMissingInformation | {} => {
    const [documentRequestStatus, setDocumentRequestStatus] = useState<
        TaxpayerMissingInformation | PayoutMissingInformation | {}
    >(TAXPAYER_SUMMARY_STATUS['none']);

    useEffect(() => {
        getTaxpayerInformationSummaryPromise(organizationId)
            .then(
                (
                    drStatus:
                        | TaxpayerMissingInformation
                        | PayoutMissingInformation
                        | {},
                ) => {
                    setDocumentRequestStatus(drStatus);
                },
            )
            .catch((drStatus) => {
                setDocumentRequestStatus(drStatus);
            });
    }, [organizationId]);

    return documentRequestStatus;
};
